import { render, staticRenderFns } from "./AjusteContaDetail.vue?vue&type=template&id=66a2fef4"
import script from "./AjusteContaDetail.vue?vue&type=script&lang=js"
export * from "./AjusteContaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports